<su-headline h="h1" skin="primary">{{ headline }}</su-headline>

<div class="location-width">
  <formly-form
    [form]="form"
    [fields]="formFields"
    [model]="formModel"></formly-form>
</div>

<div
  class="button-row"
  *ngIf="
    selectedLocation ||
    isStrategicBusinessUnitSelected ||
    isCostcenterUsageSelected
  ">
  <su-button
    [hidden]="!selectedLocation"
    skin="primary"
    icon="plus"
    [label]="'accountingArea.accounting_areas.label__vb' | translate"
    [matTooltip]="'accountingArea.accounting_areas.label__vb' | translate"
    (onClick)="onAddVerrechnungsbereich()"></su-button>

  <su-button
    [hidden]="!isStrategicBusinessUnitSelected"
    skin="primary"
    [label]="'accountingArea.accounting_areas.label__sbu' | translate"
    (onClick)="onSBUClick()"></su-button>

  <su-button
    [hidden]="!isCostcenterUsageSelected"
    skin="primary"
    [label]="
      'accountingArea.accounting_areas.label__cc_usage_share' | translate
    "
    (onClick)="onKstNutzungsaClick()"></su-button>
</div>

<div class="card-container">
  <su-card [card]="cardArchitecture" class="content-card-override">
    <div card-content>
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node
          *matTreeNodeDef="let node; when: hasChild"
          matTreeNodePadding>
          <button
            mat-icon-button
            matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.name">
            <mat-icon>
              {{
                treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'
              }}
            </mat-icon>
          </button>
          <a
            *ngIf="node.type === 'ZRM' || node.type === 'ZAP'"
            (click)="onNodeClick(node)"
            class="pointer"
            >{{ node.name }}</a
          >
          <span
            *ngIf="
              node.level > 0 &&
              (node.type === 'ZGE' ||
                node.type === 'ZGSC' ||
                node.type === 'ZGS')
            "
            >{{ node.name }}</span
          >
          <span
            *ngIf="node.level === 0"
            class="hover-vb"
            [matTooltip]="
              'accountingArea.accounting_areas.edit_dialog.headline_vb_edit'
                | translate
            "
            (click)="onEditVB(node)"
            >{{ node.name }}</span
          >
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <a
            *ngIf="
              node.type === 'ZRM' || node.type === 'ZAP' || node.vbId !== ''
            "
            (click)="onNodeClick(node)"
            class="pointer node-padding"
            >{{ node.name }}</a
          >
          <span
            *ngIf="
              (node.type === 'ZGE' ||
                node.type === 'ZGSC' ||
                node.type === 'ZGS') &&
              node.vbId === ''
            "
            >{{ node.name }}</span
          >
        </mat-tree-node>
      </mat-tree>

      <span *ngIf="dataSource.data.length === 0">{{
        'accountingArea.accounting_areas.select_location' | translate
      }}</span>
    </div>
  </su-card>

  <su-card
    [card]="cardView"
    class="content-card-override"
    [ngClass]="{ 'custom-style': isCustomStyleActive }">
    <div card-content>
      <div style="height: 500px">
        <div class="views-button-container">
          <button
            type="button"
            mat-raised-button
            color="secondary"
            *ngFor="let view of views"
            [class.active]="view.value === selectedViewType"
            (click)="selectView(view.value)">
            {{ view.name }}
          </button>
          &nbsp; &nbsp; &nbsp;
          <button
            type="button"
            mat-raised-button
            disabled="true"
            color="accent"
            (click)="scrollToToday()">
            {{ 'accountingArea.accounting_areas.today' | translate }}
          </button>
        </div>

        <app-gantt-flat
          #gantt
          [items]="items"
          [viewOptions]="viewOptions"
          [groups]="groups"
          [viewType]="options.viewType"
          [draggable]="options.draggable"
          [styles]="options.styles"
          (barClick)="barClick($event)"
          [hasSideContent]="false">
          <ng-template #group let-group="group"></ng-template>
          <ng-template #bar let-item="item">
            <div
              class="bar-content"
              matTooltipClass="my-tooltip"
              [matTooltip]="getTooltip(item)">
              <span
                [ngStyle]="{
                  color: item.color === '#e82010' ? '#FFFFFF' : '#000000',
                  'font-weight': 'bold',
                }"
                >&nbsp;&nbsp;{{ item.title }}
              </span>
            </div>
          </ng-template>
        </app-gantt-flat>
      </div>
      <div class="button-container">
        <su-button
          skin="secondary"
          icon="arrows-left-right"
          [title]="buttonMaxWidthTitle"
          (onClick)="toggleStyle()"
          [ariaLabel]="buttonMaxWidthTitle"></su-button>
      </div>
    </div>
  </su-card>
</div>

<app-spinner-overlay [show]="isLoading" [label]="''"></app-spinner-overlay>
